import { render, staticRenderFns } from "./Tatil.vue?vue&type=template&id=42653dfd&scoped=true&"
import script from "./Tatil.vue?vue&type=script&lang=js&"
export * from "./Tatil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42653dfd",
  null
  
)

export default component.exports